export function puedeInsertar(tipo_expediente) {
  if (tipo_expediente?.puede_insertar) {
    return (
      tipo_expediente &&
      (tipo_expediente?.puede_insertar === 'S' || tipo_expediente?.puede_insertar === 'true')
    )
  } else {
    // Si el paquete no devuelve la parametrizacion
    return true
  }
}

export function puedeConsultar(tipo_expediente) {
  if (tipo_expediente?.puede_consultar) {
    return (
      tipo_expediente &&
      (tipo_expediente?.puede_consultar === 'S' || tipo_expediente?.puede_consultar === 'true')
    )
  } else {
    // Si el paquete no devuelve la parametrizacion
    return true
  }
}

export function puedeActualizar(tipo_expediente) {
  if (tipo_expediente?.puede_actualizar) {
    return (
      tipo_expediente &&
      (tipo_expediente?.puede_actualizar === 'S' || tipo_expediente?.puede_actualizar === 'true')
    )
  } else {
    // Si el paquete no devuelve la parametrizacion
    return true
  }
}
